import Vue from 'vue';
import Main from './main.vue';
import { PopupManager } from 'vue-xpc/src/utils/popup';
import { isVNode } from 'vue-xpc/src/utils/vdom';
let MessageConstructor = Vue.extend(Main);
/**
 * 消息实例堆栈，成员格式
 * {
 *    id: xxx,
 *    instance: xxx,
 *    message: xxx,
 *    type: xxx,
 * }
 */
let messageStack = [];
/**
 * 消息对象入栈
 * @param {*} instance
 */
const pushMessageStack = _instance => {
  messageStack.push({
    id: _instance.id,
    instance: _instance,
    message: _instance.message,
    type: _instance.type
  });
};
/**
 * 消息对象出栈
 * @param {*} instance
 */
const popMessageStack = id => {
  messageStack = messageStack.filter(item => item.id !== id);
};
/**
 * 所有消息出栈
 */
const popMessageStackAll = () => {
  messageStack = [];
};
/**
 * 消息对象添加节流处理
 * @param {*} options
 * @returns 是否节流成功
 */
const throttleMessageIfExist = options => {
  let stackItem = messageStack.find(
    item => item.message === options.message && item.type === options.type
  );
  if (stackItem) {
    stackItem.instance.clearTimer();
    stackItem.instance.startTimer();
    return true;
  }
  return false;
};
let instance;
let instances = [];
let seed = 1;
const Message = function (options) {
  if (Vue.prototype.$isServer) return;
  options = options || {};
  if (typeof options === 'string') {
    options = { message: options };
  }
  options.type = options.type || 'info';
  if (throttleMessageIfExist(options)) {
    return;
  }
  let userOnClose = options.onClose;
  let id = 'message_' + seed++;
  options.onClose = function () {
    Message.close(id, userOnClose);
  };
  instance = new MessageConstructor({
    data: options,
    mounted () {
      if (window.ResizeObserver) {
        let ob = new ResizeObserver(() => {
          if (instances.length === 0) {
            return;
          }
          let res = instances[0].offset || 20;
          instances.forEach(item => {
            item.verticalOffset = res;
            res += item.$el.offsetHeight + 16;
          });
        });
        ob.observe(this.$el);

        this.$once('hook:beforeDestroy', () => {
          ob.unobserve(this.$el);
        });
      }
    }
  });
  instance.id = id;
  if (isVNode(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  }
  instance.$mount();
  let messageWrapper =
    document.querySelector(options.wrapperClass) || document.body;
  messageWrapper.appendChild(instance.$el);
  // 左侧菜单
  let contentSelector = document.querySelector(options.contentSelector);
  // 菜单宽度
  if (contentSelector) {
    let contentWidth = getComputedStyle(contentSelector).width;
    // 相对于左侧菜单，限制最大最小宽度，控制固定定位的位置
    instance.$el.style.maxWidth = parseInt(contentWidth) * 0.6 + 'px';
    instance.$el.style.right = parseInt(contentWidth) * 0.5 + 'px';
  } else {
    // 找视口宽度
    instance.$el.style.right = window.innerWidth * 0.5 + 'px';
  }
  let verticalOffset = options.offset || 20;
  instances.forEach(item => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  instance.verticalOffset = verticalOffset;
  instance.visible = true;
  instance.$el.style.zIndex = PopupManager.nextZIndex();
  instances.push(instance);
  pushMessageStack(instance);
  return instance;
};
['success', 'warning', 'info', 'error'].forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return Message(options);
  };
});
Message.close = function (id, userOnClose) {
  let len = instances.length;
  let index = -1;
  let removedHeight;
  for (let i = 0; i < len; i++) {
    if (id === instances[i].id) {
      removedHeight = instances[i].$el.offsetHeight;
      index = i;
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
  popMessageStack(id);
  if (len <= 1 || index === -1 || index > instances.length - 1) return;
  for (let i = index; i < len - 1; i++) {
    let dom = instances[i].$el;
    dom.style['top'] =
      parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
  }
};
Message.closeAll = function () {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
  popMessageStackAll();
};
export default Message;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/message/src/main.js